import { render, staticRenderFns } from "./sideNav.vue?vue&type=template&id=4f11ee00&scoped=true"
import script from "./sideNav.vue?vue&type=script&lang=js"
export * from "./sideNav.vue?vue&type=script&lang=js"
import style0 from "./sideNav.vue?vue&type=style&index=0&id=4f11ee00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f11ee00",
  null
  
)

export default component.exports